module.exports = __webpack_public_path__ + "img/process_medium.68b60b4e.webp";